export type { MediaData } from './base';
export { ContentTypeSchema, MediaDataSchema } from './base';
export {
  createMediaResources,
  mapCreateToFhirMedia,
  mapFhirToModelMedia,
  mapFhirToModelMediaWithId,
  mapModelToFhirMedia,
  mapModelToFhirMediaUpdate,
} from './mapping';
export type {
  CreateDownloadUrlResponse,
  CreateMediaData as CreateData,
  CreateMediaData,
  CreateMediaRequest,
  CreateMediaResponse,
  CreateUploadUrlRequest,
  CreateUploadUrlResponse,
  GetAllMediaParams,
  GetAllMediaResponse,
  GetAllMediaSearchParams,
  Media,
  MediaCreateItem,
  MediaGetResponse,
  PatientMediaCreateRequest,
} from './schema';
export {
  CreateUploadURLSchema,
  CreateUploadUrlResponseSchema,
  MediaCreateSchema,
  MediaGetAllResponseSchema,
  MediaGetResponseSchema,
  MediaItemCreateSchema,
  MediaSchema,
  PatientMediaCreateSchema,
  PatientMediaSearchSchema,
} from './schema';
export {
  createMediaDataSchema,
  createMediaRequestSchema,
  createUploadUrlRequestSchema,
} from './validation';
